import Vue from 'vue';
import { getQueryParams } from '@/utils/url';
Vue.prototype.$route = {
  query: getQueryParams()
};